/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-01-05 10:30:50
 *
 *******************************************************/
//@flow
import React from 'react';
import { Select, InlineError } from '@shopify/polaris';
import { RenderLabelTooltip } from './render-label-tooltip';

export const RenderSelect = (field: Object) => {
  const options = field.options
    ? field.options.map(function (option) {
        // eslint-disable-next-line no-unused-vars
        const { prefix, ...optionWithoutPrefix } = option;
        return optionWithoutPrefix;
      })
    : [];
  return (
    <div>
      <RenderLabelTooltip label={field.label} tooltip={field.tooltip} />
      <Select
        id={field.input.name}
        options={options}
        onChange={value => {
          // Parse value before updating
          if (field.dataType === 'integer') {
            value = parseInt(value);
          }

          field.input.onChange(value);
        }}
        value={field.input.value}
        disabled={field.disabled}
        placeholder={field.placeholder}
      />
      {field.helperText ? <p style={{ marginTop: '4px' }}>{field.helperText}</p> : ''}
      {!!field.meta.error && !!field.meta.touched ? <InlineError message={field.meta.error} /> : ''}
    </div>
  );
};
